import '../_virtual/index.js';
import { StorageType } from '@ssml-editor/core';

const DefaultEditorConfig = {
  databaseName: "default",
  scroll: true,
  readOnly: false,
  autoFocus: false,
  animation: {
    zoom: true,
    grayscale: true
  },
  html: {
    storageType: StorageType.NONE,
    storeName: "html",
    reader: () => {
      return Promise.resolve("");
    },
    saver: () => {
      return Promise.resolve(true);
    },
    autoSave: true,
    autoSaveWait: 5e3
  },
  style: {
    minHeight: "18.75rem",
    maxHeight: "34.75rem"
  },
  toolbar: {
    menus: []
  },
  normalizers: []
};

export { DefaultEditorConfig };
//# sourceMappingURL=editor-config.js.map
